/* eslint-disable complexity */
/* eslint-disable max-len */
/* eslint-disable max-lines-per-function */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-lines */
/* eslint-disable no-nested-ternary */
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from '@mui/material';
import { ChangeEvent, useContext, useEffect } from 'react';
import { PatternFormat } from 'react-number-format';

import {
  convertClientKind,
  convertEvaluationType,
  convertPropertyType,
} from '../../api/enumerations';
import { AllAttachments } from '../../components/AllAttachments';
import ConfirmationDeleteDialog from '../../components/ConfirmationDeleteDialog';
import ConfirmationDialog from '../../components/ConfirmationDialog';
import {
  CustomTextField,
  NumericTextField,
  SelectTextField,
} from '../../components/CustomInput';
import { FacadeModal } from '../../components/FacadeModal';
import StandardMap from '../../components/Maps/StandardMap';
import MapSearchButton from '../../components/MapSearchButton';
import { MessagesDialog } from '../../components/Messages';
import { PeptDialog } from '../../components/PeptDialog';
import { AccordionTitle } from '../../components/Sections/AccordionTitle';
import { AssociatedWorkOrders } from '../../components/Sections/AssociatedWorkOrders';
import { ClientData } from '../../components/Sections/ClientData';
import { FormResponse } from '../../components/Sections/FormResponse';
import { HiveDeadlineBar } from '../../components/Sections/HiveDeadlineBar';
import { WorkOrderProgressBar } from '../../components/Sections/ProgressBar';
import { PropertyAddressWithMaps } from '../../components/Sections/PropertyAddressWithMaps';
import { PropertyData } from '../../components/Sections/PropertyData';
import { PropertyInfo } from '../../components/Sections/PropertyInfo';
import { Rooms } from '../../components/Sections/Rooms';
import { ScheduleInfo } from '../../components/Sections/ScheduleInfo';
import { Title } from '../../components/Sections/Title';
import { ToogleAccordion } from '../../components/Sections/ToogleAccordion';
import Snackbar from '../../components/Snackbar';
import {
  BoxContainer,
  CancelOsBox,
  FlexBox,
  FlexSpaceBetweenBox,
  LoadingBox,
  SectionBox,
} from '../../components/UI/Box';
import { BackButton } from '../../components/UI/Button';
import { GridContainer } from '../../components/UI/Grid';
import {
  ColoredCircularProgress,
  StyledTextField,
  WhiteCircularProgress,
} from '../../components/UI/Typography';
import { factorTypes } from '../../constants/evaluationTypes';
import {
  IconApartmentMS,
  IconArrowCircleLeftMS,
  IconCalendarTodayMS,
  IconDownloadMS,
  IconEditNoteMS,
  IconListAltMS,
  IconLocationCityMS,
  IconLocationOnMS,
  IconPersonMS,
  IconPhotoLibraryMS,
  IconUploadMS,
} from '../../constants/icons';
import { Constants } from '../../constants/inspection';
import {
  independentStructuresGroup,
  parcelGroup,
  selectConcept,
  selectConservation,
  selectPropertyUse,
  selectRegistrationUf,
  selectReportFunction,
  selectReportGoal,
  selectStandard,
} from '../../constants/selectOptions';
import { GlobalContext } from '../../context/global';
import { useAccordion } from '../../hooks/useAccordion';
import { useCancelWorkOrder } from '../../hooks/useCancelWorkOrder';
import { useChangeStatus } from '../../hooks/useChangeStatus';
import useGeneral from '../../hooks/useGeneral';
import { InspectionForm } from './Form';
import {
  AddedFacadeButton,
  ButtonBox,
  ButtonContainer,
  ButtonTitle,
  ConfirmEditButton,
  DownloadButton,
  EditButton,
  FacadeImage,
  Flex,
  InputTitle,
  SectionTitle,
  StyledInput,
  SubmitBox,
  UploadButton,
} from './styles';
import useInspection from './useInspection';

export function Inspection(): JSX.Element {
  const { openSnackbar, isHiveOwner } = useContext(GlobalContext);
  const { handleCancelWorkOrder } = useCancelWorkOrder();
  const { osId, navigateHome, handleDownloadFile } = useGeneral();
  const { handlePreviousStatus, loadingPreviousStatus, loadingApprove } =
    useChangeStatus();
  const {
    expandOne,
    setExpandOne,
    expandTwo,
    setExpandTwo,
    expandThree,
    setExpandThree,
    expandFour,
    setExpandFour,
    expandFive,
    setExpandFive,
    expandSix,
    setExpandSix,
    expandAll,
    setExpandAll,
    toggleAccordions,
  } = useAccordion();
  const {
    handleProgress,
    handleSubmit,
    verifyCep,
    handleFileUpload,
    address,
    setAddress,
    addressNumber,
    setAddressNumber,
    isWithoutNumber,
    setIsWithoutNumber,
    age,
    setAge,
    buildingStandard,
    setBuildingStandard,
    builtArea,
    setBuiltArea,
    cep,
    city,
    setCity,
    client,
    setClient,
    complement,
    setComplement,
    concept,
    setConcept,
    conservation,
    setConservation,
    district,
    setDistrict,
    goal,
    setGoal,
    judicialDistrict,
    setJudicialDistrict,
    parkingLots,
    setParkingLots,
    propertyFunction,
    setPropertyFunction,
    propertyUse,
    setPropertyUse,
    registerNumber,
    setRegisterNumber,
    registryOffice,
    setRegistryOffice,
    book,
    setBook,
    registrationUf,
    setRegistrationUf,
    propertyRooms,
    setPropertyRooms,
    rooms,
    solicitor,
    setSolicitor,
    suites,
    setSuites,
    toilets,
    setToilets,
    totalArea,
    setTotalArea,
    uf,
    setUf,
    zone,
    setZone,
    propertyData,
    registerFileName,
    iptuFileName,
    searchMap,
    setSearchMap,
    isAddressEdited,
    setIsAddressEdited,
    hasSearched,
    setHasSearched,
    pinPlace,
    setPinPlace,
    questionForm,
    progressValue,
    inspectionId,
    openAddFacadeModal,
    setOpenAddFacadeModal,
    enableEditing,
    setEnableEditing,
    handleCheckLocation,
    checkLocationDate,
    handleApprove,
    loadingPage,
    submitLoading,
    downloadIptu,
    downloadRegister,
    getDataCallback,
    completedSections,
    handleUpdateForm,
  } = useInspection();
  const { setOpenSnackbar, setErrorMessage, setSnackbarMessage } =
    useContext(GlobalContext);

  const isPrivateUnit =
    propertyData?.real_estate_kind !== undefined &&
    independentStructuresGroup.has(propertyData?.real_estate_kind);
  const isParcelGroup =
    propertyData?.real_estate_kind !== undefined &&
    parcelGroup.has(propertyData?.real_estate_kind);

  useEffect(() => {
    if (
      expandOne &&
      expandTwo &&
      expandThree &&
      expandFour &&
      expandFive &&
      expandSix
    ) {
      setExpandAll(true);
    } else {
      setExpandAll(false);
    }
  }, [expandOne, expandTwo, expandThree, expandFour, expandFive, expandSix]);

  return (
    <GridContainer>
      <BackButton onClick={navigateHome}>{IconArrowCircleLeftMS}</BackButton>
      <BoxContainer component="form" id="inspection" onSubmit={handleSubmit}>
        <Title
          osNumber={propertyData?.reference_number || 0}
          title={Constants.inspection}
          createdAt={propertyData?.created_at}
        />
        {loadingPage ? (
          <LoadingBox>
            <ColoredCircularProgress />
          </LoadingBox>
        ) : (
          <>
            {isHiveOwner && propertyData && propertyData.hive_request && (
              <HiveDeadlineBar
                slaStatus={propertyData.sla_status}
                slaDaysElapsed={propertyData.sla_days_elapsed}
                slaDaysRemaining={propertyData.sla_days_remaining}
                requestCreatedAt={propertyData.hive_request.created_at}
                requestLimitDate={propertyData.hive_request.complete_until}
              />
            )}
            <FlexSpaceBetweenBox>
              <FlexBox>
                <CancelOsBox>
                  <ConfirmationDeleteDialog
                    iconCancel
                    title={Constants.cancelOs}
                    text={Constants.cancelOsText}
                    modalCallback={handleCancelWorkOrder}
                  />
                </CancelOsBox>
                {!isHiveOwner && (
                  <EditButton
                    disableTouchRipple
                    onClick={() => setEnableEditing(!enableEditing)}
                  >
                    {IconEditNoteMS}
                    {enableEditing ? Constants.cancelEdit : Constants.edit}
                  </EditButton>
                )}
              </FlexBox>
              <Box display="flex" gap={1.2}>
                {isHiveOwner && (
                  <MessagesDialog
                    osId={osId}
                    hiveRequest={propertyData?.hive_request || undefined}
                  />
                )}
                <AllAttachments propertyData={propertyData} osId={osId} />
              </Box>
            </FlexSpaceBetweenBox>
            <WorkOrderProgressBar complete>
              <>
                {enableEditing ? (
                  <SectionBox>
                    <SectionTitle>
                      {IconPersonMS}
                      {Constants.clientData}
                    </SectionTitle>
                    <Grid container spacing={4}>
                      <Grid item xs={6} xl={4}>
                        <CustomTextField
                          required
                          id="client"
                          label="proprietário do imóvel"
                          value={client}
                          setValue={setClient}
                        />
                      </Grid>
                      <Grid item xs={6} xl={4}>
                        <CustomTextField
                          id="solicitor"
                          label="solicitante"
                          value={solicitor}
                          setValue={setSolicitor}
                        />
                      </Grid>
                      <Grid item xs={6} xl={4}>
                        <SelectTextField
                          id="os-goal"
                          label="objetivo"
                          value={goal}
                          setValue={setGoal}
                          selectOptions={selectReportGoal()}
                        />
                      </Grid>
                      <Grid item xs={6} xl={3}>
                        <InputTitle>{Constants.evaluationType}</InputTitle>
                        <StyledInput>
                          {propertyData &&
                            convertEvaluationType(propertyData.evaluation_type)}
                        </StyledInput>
                      </Grid>
                      <Grid item xs={4} xl={3}>
                        <InputTitle>{Constants.clientType}</InputTitle>
                        <StyledInput>
                          {propertyData &&
                            convertClientKind(propertyData.client_kind)}
                        </StyledInput>
                      </Grid>
                      <Grid item xs={4} xl={3}>
                        <SelectTextField
                          id="os-function"
                          label="finalidade"
                          value={propertyFunction}
                          setValue={setPropertyFunction}
                          selectOptions={selectReportFunction()}
                        />
                      </Grid>
                      <Grid item xs={4} xl={3}>
                        <SelectTextField
                          id="property-use"
                          label="uso do imóvel"
                          value={propertyUse}
                          setValue={setPropertyUse}
                          selectOptions={selectPropertyUse()}
                        />
                      </Grid>
                    </Grid>
                  </SectionBox>
                ) : (
                  <ClientData propertyData={propertyData} />
                )}
                <ToogleAccordion expand={expandAll} toogle={toggleAccordions} />
              </>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete>
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyData}
                  icon={IconApartmentMS}
                  openAccordion={expandOne}
                  setOpenAccordion={setExpandOne}
                />
                {expandOne &&
                  (enableEditing ? (
                    <>
                      <Typography>{Constants.downloadText}</Typography>
                      <ButtonContainer>
                        <ButtonBox>
                          <ButtonTitle>
                            {Constants.propertyRegister}
                          </ButtonTitle>
                          {downloadRegister.length > 0 ? (
                            <DownloadButton
                              onClick={() => {
                                if (downloadRegister)
                                  handleDownloadFile(
                                    downloadRegister,
                                    'matricula'
                                  );
                              }}
                            >
                              {IconDownloadMS}
                              {Constants.download}
                            </DownloadButton>
                          ) : (
                            <>
                              <label htmlFor="uploadRegister">
                                <input
                                  accept="image/*,application/pdf"
                                  id="uploadRegister"
                                  type="file"
                                  style={{ display: 'none' }}
                                  onChange={async (
                                    e: ChangeEvent<HTMLInputElement>
                                  ) => handleFileUpload(e, 'register')}
                                />
                                <UploadButton
                                  variant="contained"
                                  component="span"
                                >
                                  {IconUploadMS}
                                  {Constants.upload}
                                </UploadButton>
                              </label>
                              {registerFileName && (
                                <Box mt={1}>{registerFileName}</Box>
                              )}
                            </>
                          )}
                        </ButtonBox>
                        <ButtonBox>
                          <ButtonTitle>{Constants.iptu}</ButtonTitle>
                          {downloadIptu.length > 0 ? (
                            <DownloadButton
                              onClick={() => {
                                if (downloadIptu)
                                  handleDownloadFile(downloadIptu, 'iptu');
                              }}
                            >
                              {IconDownloadMS}
                              {Constants.download}
                            </DownloadButton>
                          ) : (
                            <>
                              <label htmlFor="uploadIptu">
                                <input
                                  accept="image/*,application/pdf"
                                  id="uploadIptu"
                                  type="file"
                                  style={{ display: 'none' }}
                                  onChange={async (
                                    e: ChangeEvent<HTMLInputElement>
                                  ) => handleFileUpload(e, 'iptu')}
                                />
                                <UploadButton
                                  variant="contained"
                                  component="span"
                                >
                                  {IconUploadMS}
                                  {Constants.upload}
                                </UploadButton>
                              </label>
                              {iptuFileName && <Box mt={1}>{iptuFileName}</Box>}
                            </>
                          )}
                        </ButtonBox>
                      </ButtonContainer>
                      <Grid container spacing={4}>
                        <Grid item xs={3}>
                          <CustomTextField
                            required
                            id="register-number"
                            label="nº da matrícula"
                            value={registerNumber}
                            setValue={setRegisterNumber}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <CustomTextField
                            required
                            id="registry-office"
                            label="código do cartório (cns)"
                            value={registryOffice}
                            setValue={setRegistryOffice}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <CustomTextField
                            required
                            id="register-number"
                            label="livro de registro"
                            value={book}
                            setValue={setBook}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <InputTitle>tipo do imóvel:</InputTitle>
                          <StyledInput>
                            {propertyData &&
                              convertPropertyType(
                                propertyData.real_estate_kind
                              )}
                          </StyledInput>
                        </Grid>
                        <Grid item xs={3}>
                          <SelectTextField
                            id="concept"
                            label="conceito do espaço"
                            value={concept}
                            setValue={setConcept}
                            selectOptions={selectConcept()}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <NumericTextField
                            id="zone"
                            label="ofício/zona"
                            suffix=""
                            maxLength={12}
                            value={zone}
                            setValue={setZone}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <CustomTextField
                            required
                            id="judicial-district"
                            label="comarca"
                            value={judicialDistrict}
                            setValue={setJudicialDistrict}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <SelectTextField
                            id="registration-uf"
                            label="UF"
                            value={registrationUf}
                            setValue={setRegistrationUf}
                            selectOptions={selectRegistrationUf()}
                          />
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    <PropertyData propertyData={propertyData} />
                  ))}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete={completedSections.propertyAddress}>
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyAddress}
                  icon={IconLocationOnMS}
                  openAccordion={expandTwo}
                  setOpenAccordion={setExpandTwo}
                />
                {expandTwo &&
                  (enableEditing ? (
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Grid container spacing={4}>
                          <Grid item xs={12}>
                            <CustomTextField
                              required
                              id="address"
                              label="logradouro"
                              value={address}
                              setValue={setAddress}
                              onChange={setIsAddressEdited}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <CustomTextField
                              required
                              id="address-number"
                              label="número"
                              disabled={isWithoutNumber}
                              value={addressNumber}
                              setValue={setAddressNumber}
                              onChange={setIsAddressEdited}
                            />
                          </Grid>
                          <Grid item xs={3} mt="6px">
                            <FormControlLabel
                              id="without-number"
                              label="Sem número"
                              control={
                                <Checkbox
                                  name="without-number"
                                  checked={isWithoutNumber}
                                  onChange={(event) => {
                                    setIsWithoutNumber(event.target.checked);
                                    setIsAddressEdited(true);
                                    if (event.target.checked)
                                      setAddressNumber('');
                                  }}
                                />
                              }
                              sx={{
                                '& .MuiTypography-root': {
                                  fontSize: '14px',
                                  lineHeight: 1.2,
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={5}>
                            <CustomTextField
                              id="complement"
                              label="complemento"
                              value={complement}
                              setValue={setComplement}
                              onChange={setIsAddressEdited}
                            />
                          </Grid>
                          <Grid item xs={7}>
                            <CustomTextField
                              required
                              id="district"
                              label="bairro"
                              value={district}
                              setValue={setDistrict}
                              onChange={setIsAddressEdited}
                            />
                          </Grid>
                          <Grid item xs={5}>
                            <PatternFormat
                              required
                              format="#####-###"
                              customInput={StyledTextField}
                              id="cep"
                              label="CEP"
                              color="secondary"
                              value={cep}
                              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                verifyCep(e.target.value)
                              }
                            />
                          </Grid>
                          <Grid item xs={7}>
                            <CustomTextField
                              required
                              id="city"
                              label="cidade"
                              value={city}
                              setValue={setCity}
                              onChange={setIsAddressEdited}
                            />
                          </Grid>
                          <Grid item xs={5}>
                            <CustomTextField
                              required
                              id="uf"
                              label="estado"
                              value={uf}
                              setValue={setUf}
                              onChange={setIsAddressEdited}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <MapSearchButton
                              cep={cep}
                              address={address}
                              addressNumber={addressNumber}
                              district={district}
                              city={city}
                              uf={uf}
                              isWithoutNumber={isWithoutNumber}
                              hasSearched={hasSearched}
                              isAddressEdited={isAddressEdited}
                              labels={{
                                searchMap: Constants.searchMap,
                                mapUpdated: Constants.mapUpdated,
                                fieldsIncomplete: Constants.fieldsIncomplete,
                              }}
                              onClick={() => {
                                setSearchMap(!searchMap);
                                setIsAddressEdited(false);
                                setHasSearched(true);
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={6}>
                        <StandardMap
                          searchMap={searchMap}
                          address={`${address} ${addressNumber}`}
                          district={district}
                          city={city}
                          uf={uf}
                          pinPlace={pinPlace}
                          setPinPlace={setPinPlace}
                          showCoords
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <PropertyAddressWithMaps
                      checkLocation
                      propertyData={propertyData}
                      handleCheckLocation={handleCheckLocation}
                      checkLocationDate={checkLocationDate && checkLocationDate}
                    />
                  ))}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete>
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyDetails}
                  icon={IconLocationCityMS}
                  openAccordion={expandThree}
                  setOpenAccordion={setExpandThree}
                />
                {expandThree &&
                  (enableEditing ? (
                    <Grid container spacing={4}>
                      <Grid item xs={2}>
                        <NumericTextField
                          id="total-area"
                          label={
                            isPrivateUnit ? 'área total' : 'área do terreno'
                          }
                          suffix=" m²"
                          decimalSeparator=","
                          decimalScale={2}
                          maxLength={18}
                          value={totalArea}
                          setValue={setTotalArea}
                        />
                      </Grid>
                      {!isParcelGroup && (
                        <>
                          <Grid item xs={2}>
                            <NumericTextField
                              id="built-area"
                              label={
                                isPrivateUnit
                                  ? 'área privativa'
                                  : 'área construída'
                              }
                              suffix=" m²"
                              decimalSeparator=","
                              decimalScale={2}
                              maxLength={18}
                              value={builtArea}
                              setValue={setBuiltArea}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <NumericTextField
                              id="rooms"
                              label="quartos"
                              suffix=" quartos"
                              maxLength={12}
                              value={propertyRooms}
                              setValue={setPropertyRooms}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <NumericTextField
                              id="toilets"
                              label="banheiros"
                              suffix=" banheiros"
                              maxLength={13}
                              value={toilets}
                              setValue={setToilets}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <NumericTextField
                              id="suites"
                              label="suítes"
                              suffix=" suítes"
                              maxLength={10}
                              value={suites}
                              setValue={setSuites}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <NumericTextField
                              id="parking-lots"
                              label="vagas de garagem"
                              suffix=" vagas"
                              maxLength={9}
                              value={parkingLots}
                              setValue={setParkingLots}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <NumericTextField
                              id="propertyAge"
                              label="idade do imóvel"
                              suffix=" anos"
                              maxLength={9}
                              value={age}
                              setValue={setAge}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <SelectTextField
                              id="conservation"
                              label="estado de conservação do imóvel"
                              value={conservation}
                              setValue={setConservation}
                              selectOptions={selectConservation()}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <SelectTextField
                              id="building-standard"
                              label="padrão construtivo"
                              value={buildingStandard}
                              setValue={setBuildingStandard}
                              selectOptions={selectStandard()}
                            />
                          </Grid>
                        </>
                      )}
                    </Grid>
                  ) : (
                    <PropertyInfo propertyData={propertyData} />
                  ))}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete>
              <SectionBox>
                <AccordionTitle
                  title={Constants.scheduleInfo}
                  icon={IconCalendarTodayMS}
                  openAccordion={expandFour}
                  setOpenAccordion={setExpandFour}
                />
                {expandFour && (
                  <Box>
                    {propertyData?.inspection?.schedule_at ? (
                      <ScheduleInfo
                        inspectionData={propertyData.inspection}
                        workerCompanyId={
                          propertyData.worker_company_id || undefined
                        }
                        showDownload
                      />
                    ) : (
                      <Typography>{Constants.noInspection}</Typography>
                    )}
                  </Box>
                )}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar complete={completedSections.propertyImages}>
              <SectionBox>
                <AccordionTitle
                  title={Constants.propertyPhotos}
                  icon={IconPhotoLibraryMS}
                  openAccordion={expandFive}
                  setOpenAccordion={setExpandFive}
                />
                {expandFive && (
                  <Box>
                    {propertyData && (
                      <Box>
                        {isHiveOwner ? (
                          propertyData?.inspection && rooms.length > 0 ? (
                            <Rooms
                              navigationPath={`${osId}/inspection/${propertyData.inspection.id}/rooms`}
                              rooms={rooms}
                              osId={osId}
                              inspectionId={propertyData.inspection.id}
                            />
                          ) : (
                            <Typography>{Constants.noPhotos}</Typography>
                          )
                        ) : propertyData.inspection?.engineer_id !== null ? (
                          <Rooms
                            navigationPath={`${osId}/inspection/${inspectionId}/rooms`}
                            rooms={rooms}
                            osId={osId}
                            inspectionStatus
                            inspectionId={propertyData.inspection?.id}
                            showUpload
                            responsiblePicture={
                              propertyData.inspection
                                ?.responsible_picture_filename
                            }
                            updatePropertyData={getDataCallback}
                          />
                        ) : propertyData.facade_image ? (
                          <FacadeImage
                            src={propertyData.facade_image}
                            alt="Facade image"
                          />
                        ) : factorTypes.includes(
                            propertyData.evaluation_type
                          ) ? (
                          <AddedFacadeButton
                            type="button"
                            onClick={() => setOpenAddFacadeModal(true)}
                          >
                            {Constants.addFacade}
                          </AddedFacadeButton>
                        ) : (
                          <Box>{Constants.noPhotos}</Box>
                        )}
                      </Box>
                    )}
                  </Box>
                )}
              </SectionBox>
            </WorkOrderProgressBar>
            <WorkOrderProgressBar
              complete={completedSections.form}
              lastAccordion
            >
              <SectionBox>
                <AccordionTitle
                  title={Constants.form}
                  icon={IconListAltMS}
                  openAccordion={expandSix}
                  setOpenAccordion={setExpandSix}
                />
                {expandSix && (
                  <Box>
                    {isHiveOwner ? (
                      propertyData?.inspection?.form_response ? (
                        <FormResponse
                          questionForm={propertyData.inspection.form_response}
                        />
                      ) : (
                        <Typography>{Constants.noForm}</Typography>
                      )
                    ) : propertyData?.inspection && questionForm ? (
                      <InspectionForm
                        questionForm={questionForm}
                        engineerId={propertyData.inspection.engineer_id}
                        inspectionId={propertyData.inspection.id}
                        progress={progressValue}
                        handleProgress={handleProgress}
                        handleUpdateForm={handleUpdateForm}
                      />
                    ) : (
                      <Typography>{Constants.noForm}</Typography>
                    )}
                  </Box>
                )}
              </SectionBox>
            </WorkOrderProgressBar>
            <AssociatedWorkOrders osId={osId} />
            {!isHiveOwner && (
              <SubmitBox>
                <PeptDialog
                  osId={osId}
                  referenceNumber={propertyData?.reference_number}
                />
                <Flex>
                  <ConfirmationDialog
                    title={Constants.previousStatus}
                    loading={loadingPreviousStatus}
                    text={Constants.previousStatusText.replace(
                      '**',
                      `${propertyData?.reference_number}`
                    )}
                    modalCallback={() =>
                      handlePreviousStatus(
                        osId,
                        propertyData?.reference_number,
                        Constants.previousStatusName
                      )
                    }
                    previous
                  />
                  {enableEditing ? (
                    <ConfirmEditButton
                      form="inspection"
                      type="submit"
                      disabled={submitLoading}
                    >
                      {submitLoading ? (
                        <WhiteCircularProgress size={22} />
                      ) : (
                        Constants.confirmEdit
                      )}
                    </ConfirmEditButton>
                  ) : checkLocationDate ? (
                    <ConfirmationDialog
                      title={Constants.approve}
                      loading={loadingApprove}
                      text={Constants.changeStatus.replace(
                        '**',
                        `${propertyData?.reference_number}`
                      )}
                      modalCallback={() => {
                        handleApprove();
                      }}
                    />
                  ) : (
                    <ConfirmEditButton
                      onClick={() => {
                        setSnackbarMessage(
                          'Localização pendente de confirmação'
                        );
                        setOpenSnackbar(true);
                        setErrorMessage(true);
                      }}
                    >
                      {Constants.approve}
                    </ConfirmEditButton>
                  )}
                </Flex>
              </SubmitBox>
            )}
          </>
        )}
      </BoxContainer>
      {openSnackbar && <Snackbar />}
      <FacadeModal
        osId={osId}
        open={openAddFacadeModal}
        onClose={() => setOpenAddFacadeModal(false)}
      />
    </GridContainer>
  );
}
